// extracted by mini-css-extract-plugin
module.exports = {"icon":"FiltersCard__icon___dQs4h"};